// extracted by mini-css-extract-plugin
export default {"button":"CurrencyChoiceButton_button__g6oTc","active":"CurrencyChoiceButton_active__lHrJ6"};